import React from "react";

import { Tag, Avatar } from "antd";

import { jobTypes } from "../../common/jobsTypes";
import { UIText, UIHeading } from "../ui/UIElements";
import styles from "../../styles/JobPostCard.module.css";

const PendingJobCard = ({ data, key }) => {
  return (
    <div key={key} className={styles.cardCon}>
      <div style={{ display: "flex", gap: 10 }}>
        {data?.DataFields?.MoreInfo?.CompanyInfo?.CompanyLogo ? (
          <Avatar
            size={40}
            src={data?.DataFields?.MoreInfo?.CompanyInfo?.CompanyLogo}
          />
        ) : (
          <Avatar className={styles.cl} size={40}>
            {data?.DataFields?.MoreInfo?.CompanyInfo?.CompanyName?.substring(
              0,
              1
            )}
          </Avatar>
        )}
        <div className={styles.textdiv}>
          <UIHeading level={4}>
            {data?.DataFields?.TempInfo?.JobTitle}
          </UIHeading>
          <div className={styles.cname}>
            <UIText level={5} type="primary">
              {data?.DataFields?.MoreInfo?.CompanyInfo?.CompanyName}
            </UIText>
          </div>
          <div className={styles.cname}></div>
          {data?.DataFields?.TempInfo?.Location === " " || null ? null : (
            <div className={styles.cityname}>
              <UIText type="secondry">
                {data?.DataFields?.TempInfo?.Location}
              </UIText>
            </div>
          )}
          <div style={{ display: "flex" }}>
            {data?.DataFields?.TempInfo?.JobType ? (
              <div className={styles.addedon}>
                <Tag color="#F4F9FF">
                  <UIText level={2} style={{ color: "#0C64AE" }}>
                    {" "}
                    {jobTypes[data?.DataFields?.TempInfo?.JobType]}
                  </UIText>
                </Tag>
              </div>
            ) : null}
            {data?.DataFields?.AddedOn ? (
              <div>
                <Tag color="#EFF2F3">
                  <UIText level={2} style={{ color: "#324c5f" }}>
                    {data?.DataFields?.AddedOn} ago
                  </UIText>
                </Tag>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingJobCard;
